<div class="fx-row fx-justify-between">
  <lib-block-title
    id="telemetry-report-title"
    [title]="labels.title">
  </lib-block-title>
  <app-button-toggle-select
    *ngIf="selectedMode$ | async as mode"
    id="button-toggle"
    [value]="mode"
    [options]="[{
      value: TelemetryReportMode.FiveMinuteTelemetry,
      label: labels.everyFiveMinutes,
    }, {
      value: TelemetryReportMode.DailyAggregate,
      label: labels.daily
    }]"
    (valueChange)="changeSelectMode($event)">
  </app-button-toggle-select>
</div>
<ng-container *ngIf="_instanceId$ | async as instanceId">

  <ng-container *ngIf="system$ | async as system">
    <ng-container *ngIf="deviceIds$ | async as deviceIds">
      <p
        *ngIf="(selectedMode$ | async) === TelemetryReportMode.FiveMinuteTelemetry"
        class="mt-3 mb-6 text-grey-400 text-normal-wrap tw-text-sm tw-font-normal">
        {{ labels.fiveMinuteContent }}
      </p>
      <p
        *ngIf="(selectedMode$ | async) === TelemetryReportMode.DailyAggregate"
        class="mt-3 mb-6 text-grey-400 text-normal-wrap tw-text-sm tw-font-normal">
        {{ labels.aggregateContent }}
      </p>

      <section class="fx-col fx-center max-w-75 fx-gap-3 mx-auto">
        <mat-form-field
          *ngIf="selectedMode$ | async as mode"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-date-range-input
            [formGroup]="selection"
            [rangePicker]="picker"
            [max]="today">
            <input
              matStartDate
              formControlName="start"
              [placeholder]="labels.startDate">
            <input
              matEndDate
              formControlName="end"
              [placeholder]="labels.endDate">
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker">
          </mat-datepicker-toggle>
          <mat-date-range-picker
            #picker
            [maxPickerRange]="exportReportMaxDaysForMode[mode]">
          </mat-date-range-picker>
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field w-full custom-border-bottom">
          <mat-select
            #devicesSelect
            multiple
            [value]="deviceIds">
            <mat-option
              *ngFor="let id of deviceIds"
              class="tw-tabular-nums tw-font-normal tw-text-base"
              [value]="id">
              {{ id }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <button
        class="custom-mat-button-primary mt-6"
        mat-button
        [disabled]="!selection.valid || !devicesSelect.value.length"
        (click)="reportRequest(system, devicesSelect.value, instanceId)">
        {{ labels.exportReport }}
      </button>
    </ng-container>
  </ng-container>
</ng-container>
